__turbopack_context__.v({
  "temporary_responsive_section_spacing": "styles-module-scss-module__D1iy9W__temporary_responsive_section_spacing",
});
